<template>
  <pl-dialog size="md_xl" :disableOutsideClick="true" :title="header" @close="$emit('close')">
    <div class="h-full flex flex-col space-y-3 px-6 mb-4 overflow-y-auto">
      <div>
        <div id="title-input flex flex-col space-y-2">
          <div class="text-sm text-blueGray-800 mb-2 font-poppins">
            <span>Title</span>
            <span class="text-red-500">*</span>
          </div>
          <input
            @keyup="point_title_error_message = ''"
            v-model="point_title"
            class="bg-white text-sm text-blueGray-700 flex-grow outline-none border border-solid border-gray-200 focus-within:border-primary px-3 py-2 w-full rounded"
          />
        </div>
      </div>
      <div class="flex-grow h-full overflow-y-auto">
        <div class="flex flex-col space-y-2 w-full mb-3">
          <div class="text-left text-blueGray-800 font-poppins">
            <span>Description</span>
          </div>
          <div class="rounded w-full border border-solid border-gray-200">
            <RichTextEditor
              api-key="no-api-key" 
              id="text-editor-point-description"
              :init="editor_options"
              v-model="point_description"
            />
          </div>
        </div>
        <div v-if="assessment_scale !== null" class="w-full">
          <h3 class="font-manrope text-base font-bold text-gray-800 mb-2.5">Rubric Levels</h3>
          <div v-for="(point, index) in points_rubric_description" :key="index">
            <div class="px-3 py-2 flex items-start space-x-2 border rounded border-solid border-gray-200 mb-2">
              <div>
                <div class="w-7 h-7 border border-solid border-gray-200 rounded flex justify-center items-center">
                  <span>{{ point.value }}</span>
                </div>
              </div>
              <div class="w-full">
                <textarea 
                  placeholder="Enter a description for this level...." 
                  class="w-full resize-none px-2 py-1.5 border border-solid border-gray-200 rounded focus-within:border-primary outline-none" 
                  :value="point.description" 
                  @input="handleUpdateDescription(index, $event.target.value)">
                </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between">
        <div>
          <button
            class="px-4 py-2 hover:bg-gray-50 rounded cursor-pointer text-blueGray-800 border border-solid border-gray-200 mr-1"
            @click="$emit('close')"
          >
            Cancel
          </button>
        </div>
        <div class="flex items-center space-x-2">
          <button v-if="!point_default" @click="handleDeletePoint()" class="bg-white border border-solid px-5 py-2 text-red-500 rounded border-red-500 hover:bg-red-50">
            <div class="flex items-center space-x-2">
              <span>Delete</span>
              <i class="fa-regular fa-trash-can"></i>
            </div>
          </button>
          <button
            class="px-5 py-2 bg-primary rounded border border-solid border-primary cursor-pointer text-white hover:bg-primary-dark"
            @click="handleSavePoint"
          >
            Save & Close
          </button>
        </div>
        
        
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import textbox from 'components/textbox.vue';
  import RichTextEditor from '@tinymce/tinymce-vue';
  import { EditorOptionsNormal } from '../utils/EditorConfig/EditorOptionsNormal';
  import { EventBus } from '../utils/event-bus';
  export default Vue.extend({
    data() {
      return {
        point_description: '',
        point_title: '',
        point_description_error_message: '',
        point_title_error_message: '',
        editor_options: EditorOptionsNormal,
        is_editor_disabled: false,
        points_rubric_description: [],
        point_is_custom: false,
        point_default: false,
      };
    },
    props: {
      activityType: {
        type: String,
        default: 'written',
      },
      tag: {
        type: String,
        default: null,
      },
      rts: {
        type: Array,
        default: [],
      },
      assessment_scale: {
        type: Number,
        default: 0
      }
    },
    components: {
      textbox,
      RichTextEditor,
    },
    mounted: async function() {
      if (this.tag) {
        const point = this.getCourseDetail.points_settings.peer_rewards.find((x) => x.tag === this.tag);
        console.log(point, 'point');
        this.point_title = point.title;
        this.point_description = point.description;
        this.point_default = point.default ? true : false;
      }

      const validTags = ['all_uses_evidence', 'all_new_insight', 'all_connects_ideas', 'all_challenges_ideas', 'all_thoughtful_question'];
      if (validTags.includes(this.tag)) {
        this.is_editor_disabled = true;
      }
      const current = this.getCourseDetail.points_settings.peer_rewards.find((x) => x.tag === this.tag);

      if (current) {
        this.point_description = Array.isArray(current.description) ? current.description[0] : current.description;

        if (current.points_description && current.points_description.length > 0) {
          if (current.points_description.length !== this.assessment_scale) {
            if (current.points_description.length > this.assessment_scale) {
              this.points_rubric_description = current.points_description.slice(0, this.assessment_scale);
            } else {
              this.points_rubric_description = [...current.points_description];
              const additionalElements = this.assessment_scale - current.points_description.length;
              for (let i = 0; i < additionalElements; i++) {
                this.points_rubric_description.push({ description: "", value: current.points_description.length + i + 1 });
              }
            }
          } else {
            this.points_rubric_description = current.points_description;
          }
        } else {
          const points_array = this.helperCreateArray(this.assessment_scale); 
          this.points_rubric_description = points_array;
        }
      }
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getCurrentRT',
        'getCurrentDiscussion',
      ]),
      header() {
        return this.tag ? 'Edit Assessment Point' : 'Create New Point';
      },
      error_present() {
        return (
          this.point_description_error_message || this.point_title_error_message
        );
      },
      currentActivity() {
        return this.activityType === 'written'
          ? this.getCurrentRT
          : this.getCurrentDiscussion;
      },
    },
    methods: {
      handleDeletePoint: async function() {
        this.$emit('deleteAssessmentPoint', this.tag);
        this.$emit('close');
      },
      createUniqueTag(title, activityType) {
        return `${activityType}${title
          .toLowerCase()
          .trim()
          .replace(/ /g, '_')}${'_'}${Math.random().toString(36).substr(2, 5)}`;
      },
      handleUpdateDescription(index, newDescription) {
        this.$set(this.points_rubric_description, index, {
          ...this.points_rubric_description[index],
          description: newDescription
        });
      },
      handleValidateForm() {
        const title_length = this.point_title.length < 2 || this.point_title.length > 24;
        const toast = { type: 'Error', message: '', time: 5000};
        if (title_length) {
          toast.message = 'Point title needs to be between 1 and 25 characters';
          EventBus.$emit('createToast', toast);
        }
        if (this.point_description.length < 2) {
          toast.message = 'Description needs to have at least 1 character';
          EventBus.$emit('createToast', toast);
        }
      },
      helperCreateArray(n) {
        let arr = [];
        for (let i = 1; i <= n; i++) {
          arr.push({description: "", value: i});
        }
        return arr;
      },
      handleSavePoint() {
        this.handleValidateForm();

        const { activityType, tag, point_title, point_description } = this;

        const prefix = 'all_';

        const new_point = {
          is_custom: true,
          description: point_description,
          points_description: this.points_rubric_description,
          tag: tag ? tag : this.createUniqueTag(this.point_title, prefix),
          title: point_title,
          amount: 1,
          category: 'impression',
          icon: 'point.good_analysis.svg',
        };
        let clonedCoursePointSettings = null;
        let clonedRTPointSettings = null;
        let payload = [];

        if (this.tag) {
          const index = this.getCourseDetail.points_settings.peer_rewards.findIndex((x) => x.tag === this.tag);
          this.getCourseDetail.points_settings.peer_rewards[index] = new_point;
          clonedCoursePointSettings = this.getCourseDetail.points_settings.peer_rewards;
          if (this.rts.length) {
            for (let i = 0; i < this.rts.length; i += 1) {
              const activities = this.activityType === 'written' ? this.getCourseDetail.roundtables : this.getCourseDetail.live_discussions;
              const rt = activities.find((r) => r.id === this.rts[i].id);
              if (rt) {
                const index_rt = rt.points_settings.peer_rewards.findIndex((x) => x.tag === this.tag);
                rt.points_settings.peer_rewards[index_rt] = new_point;
                clonedRTPointSettings = rt.points_settings.peer_rewards;
                payload.push({ id: rt.id, peer_rewards: clonedRTPointSettings });
              }
            }
          }
        } else {
          clonedCoursePointSettings = JSON.parse(JSON.stringify(this.getCourseDetail.points_settings.peer_rewards));
          clonedCoursePointSettings.push(new_point);
        }

        this.$store.dispatch('analytics','edit written roundtable - create own point type');
        this.$store.dispatch('updateCourseDetail', { id: this.getCourseDetail.id, points_settings: { peer_rewards: clonedCoursePointSettings }}).then(() => {
          if (payload.length) {
            this.$store.dispatch('updateRTsCriteria', { id: this.getCourseDetail.id, criterias: payload, activityType }).then(async() => {
              const currentActivityChanged = payload.find((x) => x.id === this.currentActivity.id);
              if (currentActivityChanged) {
                const mutation = this.activityType === 'written' ? 'UPDATE_RT_DETAILS' : 'UPDATE_LD_DETAILS';
                const peer_rewards = this.currentActivity.peer_rewards;
                const cloned_activity = Object.assign({},this.currentActivity);
                cloned_activity.points_settings = { peer_rewards };
                this.$emit('close');
                EventBus.$emit('createToast', {type: 'Success', message: 'Assessment Criteria was updated!', duration: 3000});
                await this.$store.commit(mutation, cloned_activity);
              }
              this.$emit('close');
            });
          } else {
            this.$emit('close');
          }
        });
      },
    },
  });
</script>

<style scoped lang="css"></style>



// WEBPACK FOOTER //
// createNewPointModal.vue?75f6e99a